import FancyboxTrigger from './FancyboxTrigger';

export default FancyboxTrigger;
